import React from "react";

const SalesByStaff = () => {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">👨‍💼 Sales by Staff</h2>
      <p>Show performance and total sales made by each user/staff.</p>
    </div>
  );
};

export default SalesByStaff;
